import type { RemixiconComponentType } from '@remixicon/react';
import { waadooIcons } from '../ui/icons/waadooIcons';

// Le profil « Personnalisé », commun au formulaire de création
// (`odooProjectForm/CapacityProfilePicker.tsx`) et à l'onglet
// « Configuration » (`projectEnvironments/ConfigurationTab.tsx`). Tiré de
// `odooProjectForm/capacityProfiles.ts` à l'étape 9c du plan
// « plateforme d'applications ».

export interface ProfileInfo {
  label: string;
  description: string;
  icon: RemixiconComponentType;
}

export const CUSTOM_INFO: ProfileInfo = {
  label: 'Personnalisé',
  description: 'Chaque valeur à régler, dans les bornes de la plateforme.',
  icon: waadooIcons.profileCustom,
};
